import Vue from 'vue';
// css
import hljs from 'highlight.js';
// import 'highlight.js/styles/a11y-dark.css';
// import 'highlight.js/styles/github.css';
import 'highlight.js/styles/atom-one-dark.css';
// import 'highlight.js/styles/atom-one-light.css';

// 使用主题 atom-one-dark


Vue.use(hljs.vuePlugin);